import { render, staticRenderFns } from "./WhatIs.vue?vue&type=template&id=ed3a0872&"
import script from "./WhatIs.vue?vue&type=script&lang=js&"
export * from "./WhatIs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports